import { GetFrontAnagraficheDelegatiParams } from '@framework/api-client';
import { t } from '@framework/i18n';
import { yup } from '@framework/validation';

export type AddressBookFilters = Omit<
  GetFrontAnagraficheDelegatiParams,
  'pagina' | 'limite' | 'ordinamenti'
>;

export const AddressBookFilterSchema: yup.ObjectSchema<AddressBookFilters> = yup
  .object({
    primarySearchField: yup
      .string()
      .allowNullable()
      .label(
        t(
          'address-book.filter-schema.label.ricerca-per-cf',
          'Ricerca per CF/E-Mail',
        ),
      ),
    secondarySearchField: yup
      .string()
      .allowNullable()
      .label(
        t(
          'address-book.filter-schema.label.ricerca-per-altri-campi',
          'Ricerca per altri campi',
        ),
      ),
  })
  .required()
  .noUnknown();
